import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ref-ref-customer-details',
    templateUrl: './ref-customer-details.component.html',
    styleUrls: ['./ref-customer-details.component.scss'],
    standalone: false
})
export class RefCustomerDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
